
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/streams",
      function () {
        return require("private-next-pages/[athleteSlug]/streams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/streams"])
      });
    }
  